/*
<a href="{{ gallery.link }}" class="foto-{{ loop.first ? 'big' : 'sml' }}">
                        <img src="{{ theme.link }}/img/g00.png" class="frame" />
                        {% if gallery.thumbnail %}
                            <img src="{{ gallery.thumbnail.src }}" class="player" alt="{{ gallery.title }}" />
                        {% endif %}
                        <strong>{{ gallery.title }} <span>{{ gallery.post_date|date('Y-m-d') }}</span></strong>
                    </a>
 */

//gallery
function spaGallery(themeUrl) {
  var container = $('.gallery-ajax');
  if (container.length === 0) {
    return;
  }

  var ajaxQuery;
  var cache = {};

  function loadPage(container, page) {
    if (cache.hasOwnProperty(page)) {
      container.fadeOut(function () {
        container.html(cache[page]);
        container.fadeIn();
      });

      return;
    }

    if (ajaxQuery !== undefined) {
      ajaxQuery.abort();
    }

    container.fadeOut(function () {
      ajaxQuery = $.get(
        '/wp-admin/admin-ajax.php?action=news&page=' + page,
        function (data) {
          container.html('');
          data.forEach(function (v, k) {
            var linkClass = 'sml';
            var image = extractImage(v, k);

            if (k === 0) {
              linkClass = 'big';
            }

            var link = $('<a>');
            link.attr('href', v.link);
            link.attr('class', 'foto-' + linkClass);

            link.append('<img src="' + themeUrl + '/img/g00.png" class="frame" />');

            if (image) {
              link.append('<img src="' + image + '" class="player" alt="' + v.title + '" />');
            }

            link.append('<strong>' + v.title + ' <span>' + v.date + '</span></strong>');
            container.append(link);
          });

          container.fadeIn();
          cache[page] = container.html();
        }
      );
    });
  }

  function extractImage(v, k) {
    if (k === 0 && v.images.hasOwnProperty('b')) {
      return v.images.b;
    } else if (v.images.hasOwnProperty('s')) {
      return v.images.s;
    }

    return null;
  }

  var pages = parseInt(container.data('pages'));
  if (isNaN(pages)) {
    pages = 1;
  }

  var nextBtn = $('.gallery-navi a[data-dir="next"]');
  var prevBtn = $('.gallery-navi a[data-dir="prev"]');

  nextBtn.click(function (e) {
    e.preventDefault();
    var page = container.data('page');
    page++;

    loadPage(container, page);
    container.data('page', page);
    prevBtn.css('visibility', 'visible');

    if (page >= pages) {
      $(this).css('visibility', 'hidden');
    } else {
      $(this).css('visibility', 'visible');
    }
  });

  prevBtn.click(function (e) {
    e.preventDefault();
    var page = container.data('page');
    page--;

    loadPage(container, page);
    container.data('page', page);

    nextBtn.css('visibility', 'visible');

    if (page <= 1) {
      $(this).css('visibility', 'hidden');
    } else {
      $(this).css('visibility', 'visible');
    }
  });

  if (pages > 1) {
    nextBtn.css('visibility', 'visible');
  }

  container.data('page', 1);
  loadPage(container, 1);
}
